import React from 'react';
import { Search, CheckCircle2, Shield, FileText, Headphones } from 'lucide-react';
import { benefici } from '../mockData';

const iconMap = {
  Search,
  CheckCircle2,
  Shield,
  FileText,
  Headphones
};

const BeneficiSection = () => {
  return (
    <section id="benefici" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <span className="inline-block px-4 py-2 bg-[#5FB76E]/10 text-[#5FB76E] rounded-full text-sm font-semibold mb-4">
            I Nostri Servizi
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2B7A9F] mb-6">
            Cosa ottieni con il nostro{' '}
            <span className="text-[#5FB76E]">check-up gratuito</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Un'analisi completa e professionale delle tue coperture assicurative, 
            senza impegno e completamente gratuita.
          </p>
        </div>

        {/* Benefits List */}
        <div className="space-y-6 mb-16">
          {benefici.map((beneficio, index) => {
            const IconComponent = iconMap[beneficio.icona];
            return (
              <div
                key={index}
                className="group bg-gradient-to-r from-white to-gray-50 rounded-xl p-8 shadow-md hover:shadow-2xl transition-all duration-500 hover:-translate-x-2 border-l-4 border-[#5FB76E] animate-fade-in-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex items-start space-x-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-[#5FB76E]/20 to-[#3AAFA9]/20 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                    <IconComponent className="text-[#5FB76E]" size={32} />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-[#2B7A9F] transition-colors duration-300">
                      {beneficio.titolo}
                    </h3>
                    <p className="text-lg text-gray-600 leading-relaxed">
                      {beneficio.descrizione}
                    </p>
                  </div>
                  <div className="hidden lg:block">
                    <div className="w-12 h-12 rounded-full bg-[#5FB76E]/10 flex items-center justify-center group-hover:bg-[#5FB76E]/20 transition-colors duration-300">
                      <span className="text-2xl font-bold text-[#5FB76E]">{index + 1}</span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Process Timeline */}
        <div className="bg-gradient-to-br from-[#2B7A9F]/5 to-[#3AAFA9]/5 rounded-2xl p-8 sm:p-12 animate-fade-in-up">
          <h3 className="text-3xl font-bold text-[#2B7A9F] mb-8 text-center">
            Come funziona il processo
          </h3>
          <div className="grid md:grid-cols-4 gap-6">
            <div className="text-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-[#2B7A9F] to-[#3AAFA9] rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-xl group-hover:scale-110 transition-all duration-300 shadow-lg">
                1
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Contatto</h4>
              <p className="text-gray-600 text-sm">Compila il form o chiamaci</p>
            </div>
            <div className="text-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-[#2B7A9F] to-[#3AAFA9] rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-xl group-hover:scale-110 transition-all duration-300 shadow-lg">
                2
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Analisi</h4>
              <p className="text-gray-600 text-sm">Verifica delle tue coperture</p>
            </div>
            <div className="text-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-[#2B7A9F] to-[#3AAFA9] rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-xl group-hover:scale-110 transition-all duration-300 shadow-lg">
                3
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Report</h4>
              <p className="text-gray-600 text-sm">Presentazione dei risultati</p>
            </div>
            <div className="text-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-[#5FB76E] to-[#3AAFA9] rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-xl group-hover:scale-110 transition-all duration-300 shadow-lg">
                4
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Proposta</h4>
              <p className="text-gray-600 text-sm">Soluzione personalizzata</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeneficiSection;
